"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminAcceptationPending = AdminAcceptationPending;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const styled_components_1 = __importDefault(require("styled-components"));
const react_intl_1 = require("react-intl");
const StyledPanel = (0, styled_components_1.default)(elements_1.Panel) `
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-bottom: 2rem;
	max-width: 600px;
`;
function AdminAcceptationPending({ companyName }) {
    return ((0, jsx_runtime_1.jsx)(elements_1.Holder, { children: (0, jsx_runtime_1.jsx)("div", { className: "flex-center", children: (0, jsx_runtime_1.jsxs)(StyledPanel, { className: "flex-col align-center m-b-l m-t-l", children: [(0, jsx_runtime_1.jsx)("h1", { className: "m-b-l", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.users.registration_awaits_approval" }) }), (0, jsx_runtime_1.jsx)("img", { src: "/media/illustrations/streamline-icon-app-performance-2.svg", alt: "", style: { width: '160px' } }), (0, jsx_runtime_1.jsx)("div", { className: "font-size-m m-t-l m-b-l", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.users.administrators_has_to_accept", values: {
                                companyName,
                                strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }),
                            } }) }), (0, jsx_runtime_1.jsx)(elements_1.Button, { link: "/kontakt", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.users.go_to_contact" }) })] }) }) }));
}
